import Bottombar from "@/components/bottombar"
import Button from "@/components/button"
import Combobox from "@/components/ui/combobox"
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetDescription,
} from "@/components/ui/sheet"
import { UseFormReturn } from "@/lib/form/form"
import { posthog } from "@/lib/posthog"
import { deptSchemaToFormSchema } from "@/packaging/lib/form"
import { getPrevHistory } from "@/services/packaging"
import useStore from "@/store"
import { PackagingSheets } from "@/store/packaging"
import { difference } from "lodash"
import { useEffect, useState } from "react"
import { toast } from "sonner"

export interface AddDeptSheetProps {
  form: UseFormReturn
}

export default function AddDeptSheet() {
  const {
    currSheet,
    formSchemas: forms,
    allDepartments,
    setCurrSheet,
    ...packagingStore
  } = useStore.use.packaging()
  const [selected, setSelected] = useState<string[]>([])
  const [defaultSelected, setDefaultSelected] = useState<string[]>([])

  useInit()

  function useInit() {
    useEffect(() => {
      const newSelected = forms.map((item) => item.id)
      setDefaultSelected(newSelected)
    }, [forms])
  }

  function handleOpenChange(open: boolean) {
    if (!open) {
      close()
    }
  }

  function handleSelectDept(value: string[]) {
    setSelected(value as string[])
  }

  async function handleAddDepts() {
    try {
      const newDepts = difference(selected, defaultSelected)
      if (!newDepts.length) {
        close()

        return
      }

      for (const dept of newDepts) {
        const schema = packagingStore.getDeptSchema(dept)
        if (!schema) {
          return
        }

        const form = deptSchemaToFormSchema(schema)
        packagingStore.addDeptForm(form)

        void getPrevHistory(dept)
      }

      setDefaultSelected(selected)
      close()
    } catch (err) {
      console.error(err)
      toast.error("Error adding department")
      posthog.captureException(err)
    }
  }

  function close() {
    setCurrSheet(PackagingSheets.None)
  }

  return (
    <Sheet
      open={currSheet === PackagingSheets.AddDept}
      onOpenChange={handleOpenChange}
    >
      <SheetContent
        side="bottom"
        className="shadow-drop-shadow mx-auto max-w-md rounded-t-lg"
      >
        <SheetHeader>
          <SheetTitle className="text-xl">Add Department</SheetTitle>
        </SheetHeader>

        <SheetDescription className="flex flex-col gap-5">
          <Combobox
            className="mt-6"
            label="Select Department"
            options={allDepartments}
            defaultValue={defaultSelected}
            lockDefaultValue
            multiple
            maxAllowed={defaultSelected.length + 6}
            onChange={handleSelectDept}
          />
        </SheetDescription>

        <Bottombar className="flex gap-4 bg-white">
          <Button variant="outline" onClick={close}>
            Back
          </Button>
          <Button variant="default" className="flex-1" onClick={handleAddDepts}>
            Add Department
          </Button>
        </Bottombar>
      </SheetContent>
    </Sheet>
  )
}
